var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDianpingReservationCount = function SvgDianpingReservationCount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A85",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 0.2,
    d: "M21.6 8.8a.8.8 0 0 1 .794.706l.006.094v4.8a.8.8 0 1 1-1.6 0v-4h-9.6v11.2H16a.8.8 0 1 1 0 1.6h-5.6a.8.8 0 0 1-.794-.706L9.6 22.4V9.6a.8.8 0 0 1 .706-.794L10.4 8.8zm-.363 12 .26.026q.374.03.74.132c.34.099.75.272.896.657a1 1 0 0 1 .064.303v.085l.002.04.001.357a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-.397a1 1 0 0 1 .066-.388c.132-.358.483-.537.801-.632l.095-.025a4 4 0 0 1 .49-.104l.249-.028.26-.026h.876ZM16 18.4a.8.8 0 0 1 .094 1.594L16 20h-2.4a.8.8 0 0 1-.094-1.594l.094-.006zm4.8-1.6a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2ZM16 15.2a.8.8 0 0 1 .094 1.594L16 16.8h-2.4a.8.8 0 0 1-.094-1.594l.094-.006zm2.4-3.2a.8.8 0 0 1 .094 1.594l-.094.006h-4.8a.8.8 0 0 1-.094-1.594L13.6 12z"
  }))));
};
export default SvgDianpingReservationCount;